var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 1H11V2H5V1ZM13 3H2V5H3V12.91C2.99868 13.1848 3.05183 13.4572 3.15639 13.7114C3.26096 13.9655 3.41486 14.1965 3.60919 14.3908C3.80353 14.5851 4.03446 14.739 4.28863 14.8436C4.5428 14.9482 4.81517 15.0013 5.09 15H10.73C11.332 15 11.9094 14.7608 12.3351 14.3351C12.7608 13.9094 13 13.332 13 12.73V5H14V3H13ZM7 13H6V6H7V13ZM10 13H9V6H10V13Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d2b6c44acd4d031905837618ed75e028.svg";
export { ForwardRef as ReactComponent };